var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QrcodeVue',{attrs:{"value":_vm.url,"size":120,"level":"H"}})
}
var staticRenderFns = []

export { render, staticRenderFns }